import {
  CONTENT_TYPES_SETS,
  MONETIZATION_TYPES,
  RENT_LENGTH_TYPES
} from '../../../app/core/constants'
import moment from 'moment'
/**
 * ActivationPaymentsContentAddonsCtrl controller
 */

/**
 * ActivationPaymentsContentAddonsCtrl controller
 *
 * @class ActivationPaymentsContentAddonsCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationPaymentsContentAddonsCtrl
 */
/* @ngInject */
export default function ActivationPaymentsContentAddonsCtrl ($uibModal, $http, $scope, alertLiteSvc, scope, extra, subscr) {
  const vm = this
  vm.content_types_sets = CONTENT_TYPES_SETS
  vm.timeUnits = RENT_LENGTH_TYPES
  vm.priceTypes = MONETIZATION_TYPES

  vm.subscr = subscr
  vm.isContentAddonType = scope.paymentType === 'Content_Addon'
  vm.prorateToUpcoming = false
  vm.getPaymentRequest = scope.getPaymentRequest

  if (vm.isContentAddonType) {
    scope.getChildPayment = (defaults = {}) => ({
      contentSetAddOns: vm.contentAddons || [],
      prorateToUpcoming: vm.prorateToUpcoming,
      accessoryIds: [],
      ...defaults
    })
  }
  vm.payment = () => scope.getChildPayment()
  vm.paymentType = scope.getPaymentRequest().paymentType
  vm.hasUpcomingSubscription = extra.hasUpcomingSubscription
  vm.proratingEnabled = extra.networkSettings.ADD_ON_PRORATING_ENABLED === 'true'

  scope.getContentAddons = vm.getContentAddons = function (subscrId, subscriptionId) {
    const url = `/nora/api/subscribers/${subscrId}/extra?contentAddons&prorateToUpcoming=${vm.prorateToUpcoming}` + (!vm.isContentAddonType ? `&subscriptionId=${subscriptionId}` : '')
    return $http.get(url)
      .data()
      .then((data) => {
        vm.availableContentAddons = data.contentAddons
        return data
      })
      .catch(alertLiteSvc.alertError)
  }

  vm.getContentAddons(subscr.id, scope.subscription?.id)
    .then(() => {
      vm.contentAddons = scope.selectedContentAddons = []
      if (vm.isContentAddonType) { scope.calculate() }
    })

  /**
   *
   * @function
   */
  vm.addContentAddons = function () {
    $uibModal.open({
      templateUrl: 'components/subscribers/activation/views/addContentAddons.html',
      controller: 'AddContentAddonsCtrl as vm',
      animation: false,
      size: 'xl',
      resolve: {
        addedAddons: function () {
          return vm.contentAddons
        },
        curScope: function () {
          return scope
        },
        subscr: function () {
          return vm.subscr
        }
      }
    }).result
      .then(
        function close ({ added, available }) {
          scope.selectedContentAddons = vm.contentAddons = angular.copy(added)
          vm.availableContentAddons = angular.copy(available)
          scope.calculate()
        }
      )
  }

  vm.deleteContentAddon = function (index) {
    const deletedAddon = vm.contentAddons.splice(index, 1)[0]
    vm.availableContentAddons.push(deletedAddon)
    deletedAddon.disabled = false
    scope.selectedContentAddons = vm.contentAddons
    scope.calculate()
  }

  vm.atLeastOneBundle = function () {
    return vm.paymentType === 'Content_Addon' && !scope.selectedContentAddons.length
  }

  $scope.$watch('vm.prorateToUpcoming', () => {
    if (vm.contentAddons && vm.contentAddons.length) {
      vm.availableContentAddons = vm.availableContentAddons.concat(vm.contentAddons)
      vm.contentAddons = []
      scope.calculate()
    }
  })

  $scope.$watch('vm.payment().subscriptionId', () => {
    scope.selectedContentAddons = vm.contentAddons = []
    vm.payment().contentSetAddOns = []
  })

  $scope.$watch('vm.payment().override', () => {
    if (!vm.payment().override) {
      vm.payment().contentSetAddOns.forEach((ca, index) => {
        delete ca.$adjustEnabled
        delete vm.contentAddons[index].$adjustEnabled
      })
    }
  })

  vm.showAdjustButton = function () {
    if (vm.paymentType === 'Common_Subscription' && !vm.payment().override) {
      return false
    }
    if (vm.paymentType === 'Common_Subscription') {
      return scope.getPaymentRequest().$adjustEnabled && vm.contentAddons.reduce((acc, ca) => {
        return acc || (ca.priceType === 'RENT' && !ca.dueDate)
      }, false)
    }
    if (vm.paymentType === 'Content_Addon') {
      if (vm.subscr.currentPaymentStatement.length.includes('(') && vm.subscr.currentPaymentStatement.length.includes(')')) {
        return vm.contentAddons.reduce((acc, ca) => {
          return acc || (ca.priceType === 'RENT' && !ca.dueDate)
        }, false)
      }
    }
    return false
  }

  vm.adjustAddons = function () {
    const initialContentAddons = angular.copy(vm.contentAddons)

    let subscriptionLength, currentLength, activeFrom, activeUntil
    if (vm.paymentType === 'Common_Subscription') {
      subscriptionLength = scope.subscription.lengthType === 'Days' ? scope.subscription.length : scope.subscription.length * 30
      currentLength = subscriptionLength + (scope.getPaymentRequest().$adjustType === 'ADD' ? scope.getPaymentRequest().$extraLength : -1 * scope.getPaymentRequest().$extraLength)
      activeFrom = scope.getPaymentRequest().override ? new Date() : vm.subscr.currentPaymentStatement.activeUntil
      activeUntil = new Date(angular.copy(activeFrom).setDate(activeFrom.getDate() + currentLength))
    } else {
      activeFrom = new Date()
      activeUntil = new Date(vm.subscr.currentPaymentStatement.activeUntil)
    }

    $uibModal.open({
      templateUrl: 'components/subscribers/activation/views/adjustAddons.html',
      controller: 'AdjustAddonsCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        activeFrom: () => activeFrom,
        activeUntil: () => activeUntil,
        addons: () => vm.contentAddons.filter(ca => ca.priceType === 'RENT' && !ca.dueDate)
      }
    }).result
      .then((addons) => {
        vm.contentAddons.forEach(ca => {
          const currentAddon = addons.find(a => a.id === ca.id)
          if (currentAddon) {
            ca = currentAddon
          }
          if (Object.prototype.hasOwnProperty.call(ca, '$adjustEnabled') && !ca.$adjustEnabled) {
            delete ca.$adjustEnabled
          }
        })
        scope.selectedContentAddons = vm.contentAddons
      })
      .catch(() => {
        scope.selectedContentAddons = vm.contentAddons = angular.copy(initialContentAddons)
      })
  }

  $scope.$watch(function (scope) {
    return scope.vm.getPaymentRequest().$adjustEnabled
  }, () => {
    if (vm.contentAddons) {
      vm.contentAddons.forEach(ca => {
        if (Object.prototype.hasOwnProperty.call(ca, '$adjustEnabled')) {
          ca.$adjustEnabled = vm.getPaymentRequest().$adjustEnabled
        }
      })
    }
  })

  vm.recalculateExtraLength = function () {
    vm.contentAddons.forEach(ca => {
      if (ca.$adjustEnabled) {
        const subscriptionLength = scope.subscription.lengthType === 'Days' ? scope.subscription.length : scope.subscription.length * 30
        const currentLength = subscriptionLength + (scope.getPaymentRequest().$adjustType === 'ADD' ? scope.getPaymentRequest().$extraLength : -1 * scope.getPaymentRequest().$extraLength)
        const addonLength = ca.timeUnit[0] === 'D' ? ca.period : ca.period * 30
        ca.extraLength = currentLength - addonLength
      }
    })
  }

  vm.showLength = function (addon) {
    if (addon.periodUnlimited) {
      return '∞'
    } else if (addon.dueDate) {
      return 'to: ' + moment(addon.dueDate).format('DD.MM.YYYY')
    } else {
      return addon.period && addon.timeUnit ? addon.period + addon.timeUnit[0] : ' — '
    }
  }

  $scope.$watch(function (scope) {
    return scope.vm.getPaymentRequest().$adjustType
  }, () => {
    if (vm.getPaymentRequest().$adjustEnabled && vm.contentAddons) {
      vm.recalculateExtraLength()
    }
  })

  $scope.$watch(function (scope) {
    return scope.vm.getPaymentRequest().$extraLength
  }, () => {
    if (vm.getPaymentRequest().$adjustEnabled && vm.contentAddons) {
      vm.recalculateExtraLength()
    }
  })

  $scope.$on('$destroy', function () {
    scope.selectedContentAddons = []
  })
}
